import { Identify } from 'v2/analytics/identify';
import { User } from 'v2/core/entities/user';

export const setDataInAnalytics = (
  user: User,
  enabledFeatureFlags: string[],
) => {
  const { id, email, firstName, lastName, tenant, interests } = user;
  Identify(id, {
    firstName,
    lastName,
    email,
    tenant: {
      tenantId: tenant?.id,
      tenantName: tenant?.name,
      tenantSlug: tenant?.slug,
    },
    interests: {
      keywords: interests?.keywords,
      labelIDs: interests?.labelIDs,
    },
    enabledFeatureFlags,
  });
};
